import { IconProps } from "@/data/types"

export default function CheckMarkIcon({ width=30, height=30, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height}  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke={color} strokeWidth="0.8"/>
      <path d="M9.33398 16.8333L13.5007 20.9999L22.6673 11.8333" stroke={color} strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}